import { T_MongoDoc, T_MongoId } from "./_utils.types";
import { RoleTypes } from "./user.types";

export enum AvailablePermissions {
  CREATE = "C",
  READ = "R",
  UPDATE = "U",
  DELETE = "D",
}

export enum AvailableResources {
  USER_PROFILE = "user_profile",
  USER_MANAGEMENT = "user_management",
  LOAN = "loan",
  BANK = "bank",
  LAWSUIT = "lawsuit",
  FILE = "file",
  AGREEMENT = "agreement",
}

export type PermissionGroupDto = {
  user: T_MongoId;
  name: string;
  slug?: string;
  level?: number; // number or use as RoleType Enum
  role_type?: RoleTypes;
  // resources: {
  //     [key: string]: AvailablePermissions[];
  // };
  resources: Map<AvailableResources, AvailablePermissions> | any;
  description?: string;
};

export type PermissionGroupSchemaDto = PermissionGroupDto & T_MongoDoc;
export type CreatePermissionGroupDto = PermissionGroupDto;

// partial version of PermissionGroupDto, meaning that all the properties
// in PermissionGroupDto are optional when updating an existing permission group.
// UpdatePermissionGroupDto when you need to update some or all properties of an existing permission group.
// Since all fields are optional, this type allows for partial updates without requiring every field to be provided.
export type UpdatePermissionGroupDto = Partial<PermissionGroupDto>;

// Previous structure -
//  resources: Array<{
//     module: string;
//     permissions: [{
//         type: AvailablePermissions;
//         allow: boolean;
//     }];
// }>;
